import { Alert } from "antd";
import { captureException } from "logrocket";
import qs from "qs";
import { useEffect, useState } from "react";
import { UNKNOWN_ERROR_MESSAGE } from "../constants";
import { persistLinkState } from "../hooks/useLinkTracker";
import Store from "../stateStore";
import { STORES, extractLinkParamsFromState, getBackendUrl } from "../utils";

type XeroProps = {
  clientSecret: string;
  onBack: () => void;
  onCancel: () => void;
  onComplete: (publicToken: string) => void;
};

// This path isn't actually used for Xero.
function Xero(_props: XeroProps) {
  const store = Store.useStore();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    handleComplete();
  }, []);

  function handleAuthError(e: any) {
    captureException(e);
    if (e.response.data.error_message) {
      setError(e.response.data.error_message);
    } else {
      setError(UNKNOWN_ERROR_MESSAGE);
    }
  }

  function handleComplete() {
    try {
      persistLinkState(STORES.XERO, store.getState());
      const q = qs.stringify(extractLinkParamsFromState(store));
      const url = `${getBackendUrl()}/xero/proxy/app-url?${q}`;
      window.location.replace(url);
    } catch (e) {
      handleAuthError(e);
    }
  }

  return (
    <>
      {error && (
        <Alert
          className="mt-4"
          type="error"
          message={"Error"}
          description={error}
          showIcon></Alert>
      )}
    </>
  );
}

export default Xero;
